// Sopwith 3D - sky dome.
//
// A large inverted sphere with a vertical colour gradient: deep blue at the
// zenith, a pale haze band at the horizon. It follows the camera in X so the
// horizon never drifts.

import * as THREE from 'three';

const VERT = /* glsl */ `
  varying vec3 vWorld;
  void main() {
    vec4 w = modelMatrix * vec4(position, 1.0);
    vWorld = w.xyz;
    gl_Position = projectionMatrix * viewMatrix * w;
  }
`;

const FRAG = /* glsl */ `
  uniform vec3 top;
  uniform vec3 horizon;
  uniform float horizonY;
  varying vec3 vWorld;
  void main() {
    float t = clamp((vWorld.y - horizonY) / 900.0, 0.0, 1.0);
    t = pow(t, 0.6);
    gl_FragColor = vec4(mix(horizon, top, t), 1.0);
  }
`;

export class Sky {
  readonly mesh: THREE.Mesh;

  constructor() {
    const mat = new THREE.ShaderMaterial({
      vertexShader: VERT,
      fragmentShader: FRAG,
      uniforms: {
        top: { value: new THREE.Color(0x3b7fd6) },
        horizon: { value: new THREE.Color(0xd8ecf7) },
        horizonY: { value: 60 },
      },
      side: THREE.BackSide,
      depthWrite: false,
      fog: false,
    });
    this.mesh = new THREE.Mesh(new THREE.SphereGeometry(2500, 24, 16), mat);
    this.mesh.renderOrder = -10;
    this.mesh.frustumCulled = false;
  }

  follow(x: number): void {
    this.mesh.position.x = x;
  }
}
